import { useEffect } from 'react'


export default function MapEffectComponent({ isReady, initializeMap }) {
    useEffect(() => {
        if(isReady) {
            initializeMap();
        }
    }, [isReady, initializeMap]);
    return null
}